<a (click)="gotoResults()" [attr.title]="titleText">{{linkText || ''}}</a>
